import { render, staticRenderFns } from "./ElementFactChiefSectionTableColumn.vue?vue&type=template&id=6403c10c&scoped=true"
import script from "./ElementFactChiefSectionTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementFactChiefSectionTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementFactChiefSectionTableColumn.vue?vue&type=style&index=0&id=6403c10c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403c10c",
  null
  
)

export default component.exports